<template>
  <PSidebar
    v-model:visible="displayModal"
    :base-z-index="10000"
    position="right"
    class="sidebar"
    :style="{ maxWidth: maxWidth }"
    :class="{ 'dark-background': darkBackground }"
    @hide="onClose"
  >
    <slot name="content" />
  </PSidebar>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

type IProps = {
  visible?: boolean;
  darkBackground?: boolean;
  maxWidth?: string;
};

const props = defineProps<IProps>();
const emits = defineEmits(['update:visible']);

const displayModal = ref(false);

function onClose() {
  displayModal.value = false;
  emits('update:visible', false);
}

watch(
  () => props.visible,
  (newValue) => {
    displayModal.value = newValue;
    emits('update:visible', newValue);
  },
);
</script>

<style lang="scss">
.p-sidebar-mask {
  z-index: 10;
}
.p-sidebar-content {
  padding: 0px !important;
  height: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
.p-sidebar-right {
  width: 524px !important;
  background: #16162d;
  box-shadow: -2px 0px 4px #000000;
  border-width: 0px;
  z-index: 99;
  @media (max-width: 524px) {
    width: 100% !important;
  }
}
.dark-background {
  background: #03031c;
}
.p-sidebar-header {
  display: none;
}
.p-sidebar {
  ::-webkit-scrollbar {
    width: 12px;
    height: 280px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #e5e4fa30;
    opacity: 0.3;
    border-radius: 40px;
  }
}
</style>

<style lang="scss">
.p-overflow-hidden-fix {
  overflow: hidden !important;
}
</style>
